module.exports = __webpack_public_path__ + "img/company_qualifications.cdb7c404.jpg";